import { render, staticRenderFns } from "./NotConfiguredPayout.vue?vue&type=template&id=427ae79d&"
import script from "./NotConfiguredPayout.vue?vue&type=script&lang=ts&"
export * from "./NotConfiguredPayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports